function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.6617 1.21572C24.0392 2.8429 24.0392 5.48006 25.6617 7.12594C27.2842 8.75312 29.9137 8.75312 31.5549 7.12594C33.1774 5.49876 33.1774 2.8616 31.5549 1.21572C29.9324 -0.411465 27.2842 -0.411465 25.6617 1.21572Z",
  fill: "#D3D0D0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7393 12.3255C35.1168 13.9526 35.1168 16.5898 36.7393 18.2357C38.3618 19.8629 40.9914 19.8629 42.6325 18.2357C44.255 16.6085 44.255 13.9713 42.6325 12.3255C41.01 10.6983 38.3618 10.6983 36.7393 12.3255Z",
  fill: "#D3D0D0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.817 23.4352C46.1945 25.0624 46.1945 27.6995 47.817 29.3454C49.4395 30.9726 52.069 30.9726 53.7102 29.3454C55.3327 27.7182 55.3327 25.0811 53.7102 23.4352C52.0877 21.808 49.4395 21.808 47.817 23.4352Z",
  fill: "#D3D0D0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M58.8946 34.5449C57.2721 36.1721 57.2721 38.8092 58.8946 40.4551C60.5171 42.0823 63.1467 42.0823 64.7878 40.4551C66.4103 38.828 66.4103 36.1908 64.7878 34.5449C63.1653 32.9177 60.5171 32.9177 58.8946 34.5449Z",
  fill: "#D3D0D0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6617 73.7843C24.0392 72.1571 24.0392 69.52 25.6617 67.8741C27.2842 66.2469 29.9137 66.2469 31.5549 67.8741C33.1774 69.5013 33.1774 72.1571 31.5549 73.7843C29.9324 75.4115 27.2842 75.4115 25.6617 73.7843Z",
  fill: "#D3D0D0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7393 62.6746C35.1168 61.0474 35.1168 58.4102 36.7393 56.7644C38.3618 55.1372 40.9914 55.1372 42.6325 56.7644C44.255 58.3915 44.255 61.0474 42.6325 62.6746C41.01 64.3018 38.3618 64.3018 36.7393 62.6746Z",
  fill: "#D3D0D0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M47.817 51.5649C46.1945 49.9377 46.1945 47.3005 47.817 45.6547C49.4395 44.0275 52.069 44.0275 53.7102 45.6547C55.3327 47.2818 55.3327 49.919 53.7102 51.5649C52.0877 53.1921 49.4395 53.1921 47.817 51.5649Z",
  fill: "#D3D0D0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M58.8946 40.4551C57.2721 38.828 57.2721 36.1908 58.8946 34.5449C60.5171 32.9177 63.1467 32.9177 64.7878 34.5449C66.4103 36.1721 66.4103 38.8092 64.7878 40.4551C63.1653 42.0823 60.5171 42.0823 58.8946 40.4551Z",
  fill: "#D3D0D0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1.21345 1.2166C-0.409041 2.84378 -0.409041 5.48094 1.21345 7.12683C2.83594 8.75401 5.4655 8.75401 7.10664 7.12683C8.72913 5.49964 8.72913 2.86249 7.10664 1.2166C5.48415 -0.41058 2.85459 -0.41058 1.21345 1.2166Z",
  fill: "#D3D0D0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2901 12.3255C10.6676 13.9526 10.6676 16.5898 12.2901 18.2357C13.9126 19.8629 16.5422 19.8629 18.1833 18.2357C19.8058 16.6085 19.8058 13.9713 18.1833 12.3255C16.5608 10.6983 13.9126 10.6983 12.2901 12.3255Z",
  fill: "#D3D0D0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3677 23.4352C21.7453 25.0624 21.7453 27.6995 23.3677 29.3454C24.9902 30.9726 27.6198 30.9726 29.2609 29.3454C30.8834 27.7182 30.8834 25.0811 29.2609 23.4352C27.6384 21.808 24.9902 21.808 23.3677 23.4352Z",
  fill: "#D3D0D0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M34.4454 34.5449C32.8229 36.1721 32.8229 38.8092 34.4454 40.4551C36.0679 42.0823 38.6974 42.0823 40.3386 40.4551C41.9611 38.828 41.9611 36.1908 40.3386 34.5449C38.7161 32.9177 36.0679 32.9177 34.4454 34.5449Z",
  fill: "#D3D0D0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1.21247 73.7843C-0.410018 72.1571 -0.410018 69.52 1.21247 67.8741C2.83497 66.2469 5.46452 66.2469 7.10567 67.8741C8.72816 69.5013 8.72816 72.1571 7.10567 73.7843C5.48317 75.4115 2.85362 75.4115 1.21247 73.7843Z",
  fill: "#D3D0D0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2901 62.6746C10.6676 61.0474 10.6676 58.4102 12.2901 56.7644C13.9126 55.1372 16.5422 55.1372 18.1833 56.7644C19.8058 58.3915 19.8058 61.0474 18.1833 62.6746C16.5608 64.3018 13.9126 64.3018 12.2901 62.6746Z",
  fill: "#D3D0D0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3677 51.5649C21.7453 49.9377 21.7453 47.3005 23.3677 45.6547C24.9902 44.0275 27.6198 44.0275 29.2609 45.6547C30.8834 47.2818 30.8834 49.919 29.2609 51.5649C27.6384 53.1921 24.9902 53.1921 23.3677 51.5649Z",
  fill: "#D3D0D0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M34.4454 40.4551C32.8229 38.828 32.8229 36.1908 34.4454 34.5449C36.0679 32.9177 38.6974 32.9177 40.3386 34.5449C41.9611 36.1721 41.9611 38.8092 40.3386 40.4551C38.7161 42.0823 36.0679 42.0823 34.4454 40.4551Z",
  fill: "#D3D0D0"
});

function SvgGreater({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 75,
    viewBox: "0 0 66 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreater);
export default __webpack_public_path__ + "static/media/greater.1c7b8b48.svg";
export { ForwardRef as ReactComponent };